import React from "react";
import { RxCross2 } from "react-icons/rx";
import { removeFromCrate } from "../../store";
import { useDispatch } from "react-redux";

const CrateItem = ({ track, downloadExceeded = false }) => {
  const dispatch = useDispatch();

  const handleRemoveFromCrate = () => {
    dispatch(
      removeFromCrate(`${track.trackId}_${track.editId}_${track.version.id}`)
    );
    console.log(`${track.trackId}_${track.editId}_${track.version.id}`);

    console.log("run remove", track);
  };

  return (
    <div className="border-b border-[#1E1E1E] flex px-[20px] py-[10px] justify-between">
      <div className="flex flex-col overflow-x-auto max-w-[250px]">
        {downloadExceeded && (
          <p className="text-[11px] leading-[15px] sm:text-xs text-red-500 max-w-[250px] truncate">
            Max download limit reached
          </p>
        )}
        <p className="text-[11px] leading-[15px] sm:text-xs text-gray-500 max-w-[250px] truncate">
          {track?.artists}{" "}
          {track?.featuredArtists?.length > 0
            ? "ft " + track?.featuredArtists.join(" & ")
            : ""}
        </p>
        <p className="font-bold text-[14px] leading-[22px] sm:text-base max-w-[250px] truncate">
          {track?.trackTitle}
        </p>
        <p className="text-[11px] leading-[15px] text-xs text-gray-500 max-w-[250px] truncate">
          {track?.editTitle}
        </p>
      </div>
      <div className="flex items-center gap-4 w-fit">
        <div className="text-gray-500 border border-gray-500 rounded-md text-[11px] leading-[15px] sm:text-xs p-[6px] sm:p-2 flex justify-center items-center whitespace-nowrap">
          {track?.version?.versionType}
        </div>
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleRemoveFromCrate();
          }}
          className="text-white text-lg border border-[#2A2A2A] rounded-md p-1"
        >
          <RxCross2 size={20} />
        </button>
      </div>
    </div>
  );
};

export default CrateItem;
